__turbopack_context__.v({
  "author": "NewsAuthor-module-sass-module__MryzXW__author",
  "author-avatar": "NewsAuthor-module-sass-module__MryzXW__author-avatar",
  "author-text": "NewsAuthor-module-sass-module__MryzXW__author-text",
  "text-skeleton": "NewsAuthor-module-sass-module__MryzXW__text-skeleton",
});
